// Mock-Daten für Next Gen Business Cup Messe-Website

export const messeData = {
  name: "Straßenkickerbase",
  slogan: "Die Zukunft der Wirtschaft gestalten",
  sloganEn: "Shaping the Future of Business",
  tagline: "Wo Innovation auf Opportunity trifft",
  taglineEn: "Where Innovation Meets Opportunity",
  datum: "19. September 2026",
  datumEn: "September 19, 2026",
  ort: "Straßenkickerbase, Köln",
  ortEn: "Straßenkickerbase, Cologne",
  googleMapsUrl: "https://www.google.com/maps/place/Schanzenstra%C3%9Fe+6-20,+51063+K%C3%B6ln",
  
  highlights: [
    "300+ führende Unternehmen",
    "50+ inspirierende Vorträge",
    "10.000+ erwartete Besucher",
    "Networking-Opportunitäten"
  ],

  ueber: {
    titel: "Über die Messe",
    titelEn: "About the Event",
    beschreibung: "Der Next Gen Business Cup ist ein einzigartiges Eventformat, das Fußball, Karrieren und Networking miteinander verbindet. In der Straßenkicker Base treffen die größten Wirtschaftshochschulen Kölns aufeinander und treten in einem großen Fußballturnier gegeneinander an. Das Turnier bildet den Kern, doch der Next Gen Business Cup ist deutlich mehr als nur Sport. Rund um das Spielfeld entsteht ein interaktives Event, bei dem Studierende und Unternehmen zusammenkommen. Während auf dem Platz um den Titel gekämpft wird, entstehen daneben neue Kontakte, Karrierechancen und inspirierende Gespräche.",
    beschreibungEn: "The Next Gen Business Cup is a unique event format that combines football, careers and networking. In the Straßenkicker Base, Cologne's largest business schools meet and compete against each other in a major football tournament. The tournament is the core, but the Next Gen Business Cup is much more than just sport. Around the pitch, an interactive event brings students and companies together. While the battle for the title takes place on the field, new contacts, career opportunities and inspiring conversations arise alongside it.",
    ziele: [
      "Das Turnier - Teams der führenden Wirtschaftshochschulen Kölns treten gegeneinander an",
      "Die Karrieremesse - Unternehmen treffen ambitionierte Studierende",
      "Networking & Spotlight Zones - Raum für Gespräche und neue Kontakte",
      "Business Impact Rooms - KI-gestütztes CV-Matching und Recruiting-Gespräche"
    ],
    zieleEn: [
      "The Tournament - Teams from Cologne's leading business schools compete",
      "The Career Fair - Companies meet ambitious students",
      "Networking & Spotlight Zones - Space for conversations and new contacts",
      "Business Impact Rooms - AI-powered CV matching and recruiting conversations"
    ],
    themenschwerpunkte: [
      "Digitale Transformation",
      "Künstliche Intelligenz & Automatisierung",
      "Nachhaltiges Wirtschaften",
      "New Work & Leadership",
      "Innovation & Start-up Ökosystem"
    ]
  },

  vorteileBesucher: [
    {
      icon: "Users",
      titel: "Networking",
      beschreibung: "Knüpfen Sie wertvolle Kontakte zu Branchenführern, Entscheidern und Gleichgesinnten"
    },
    {
      icon: "Briefcase",
      titel: "Karrierechancen",
      beschreibung: "Entdecken Sie attraktive Jobangebote und sprechen Sie direkt mit Recruitern führender Unternehmen"
    },
    {
      icon: "Lightbulb",
      titel: "Innovation erleben",
      beschreibung: "Erleben Sie die neuesten Trends, Technologien und Geschäftsmodelle hautnah"
    },
    {
      icon: "GraduationCap",
      titel: "Wissenstransfer",
      beschreibung: "Profitieren Sie von Expert:innen-Vorträgen, Workshops und praxisnahen Diskussionen"
    },
    {
      icon: "TrendingUp",
      titel: "Markteinblicke",
      beschreibung: "Gewinnen Sie wertvolle Einblicke in aktuelle Markttrends und Zukunftsperspektiven"
    },
    {
      icon: "Award",
      titel: "Inspiration",
      beschreibung: "Lassen Sie sich von Success Stories und innovativen Ansätzen inspirieren"
    }
  ],

  aussteller: [
    { name: "TechCorp Industries", branche: "Technologie" },
    { name: "Innovation Labs GmbH", branche: "Forschung & Entwicklung" },
    { name: "Future Finance AG", branche: "Finanzdienstleistungen" },
    { name: "Green Solutions Ltd.", branche: "Nachhaltigkeit" },
    { name: "Digital Dynamics", branche: "IT & Software" },
    { name: "NextGen Consulting", branche: "Beratung" },
    { name: "Smart Manufacturing Co.", branche: "Industrie 4.0" },
    { name: "Healthcare Innovators", branche: "Gesundheitswesen" }
  ],

  programm: [
    {
      tag: "Freitag, 11. Juli 2026",
      events: [
        {
          zeit: "09:00 - 10:00",
          titel: "Eröffnungskeynote: Die Zukunft der Arbeit",
          typ: "Keynote",
          beschreibung: "Prof. Dr. Anna Schmidt, Zukunftsforscherin"
        },
        {
          zeit: "10:30 - 12:00",
          titel: "Panel: KI in der Unternehmenspraxis",
          typ: "Panel Discussion",
          beschreibung: "Führende Expert:innen diskutieren praktische Anwendungen"
        },
        {
          zeit: "13:00 - 14:30",
          titel: "Workshop: Agile Transformation",
          typ: "Workshop",
          beschreibung: "Interaktiver Workshop für Führungskräfte"
        },
        {
          zeit: "15:00 - 16:30",
          titel: "Start-up Pitch Session",
          typ: "Pitch",
          beschreibung: "Innovative Start-ups präsentieren ihre Geschäftsideen"
        },
        {
          zeit: "17:00 - 19:00",
          titel: "Networking-Empfang",
          typ: "Networking",
          beschreibung: "Get-together mit Snacks und Getränken"
        },
        {
          zeit: "19:30 - 21:00",
          titel: "Awards Ceremony & Abschluss",
          typ: "Award",
          beschreibung: "Verleihung des Next Gen Business Awards"
        }
      ]
    }
  ],

  location: {
    name: "Straßenkickerbase Köln",
    adresse: "Straßenkickerbase, Köln",
    beschreibung: "Die Straßenkickerbase in Köln bietet die perfekte Location für den Next Gen Business Cup. Mit ihrer urbanen Atmosphäre und modernen Ausstattung schafft sie den idealen Rahmen für Innovation, Networking und Business.",
    anfahrt: {
      oeffentlich: "S-Bahn & U-Bahn: Verschiedene Linien nach Köln | Busverbindungen vor Ort",
      auto: "A57, A1, A4 - Zentrale Lage in Köln | Parkplätze vor Ort verfügbar",
      flughafen: "15 Minuten vom Flughafen Köln/Bonn"
    },
    ausstattung: [
      "Moderne Event-Location",
      "Hochwertige Veranstaltungstechnik",
      "Gastronomie & Catering vor Ort",
      "Barrierefreier Zugang",
      "WLAN im gesamten Bereich"
    ]
  },

  vorteileAussteller: [
    {
      icon: "Target",
      titel: "Zielgruppenreichweite",
      beschreibung: "Erreichen Sie über 10.000 qualifizierte Besucher aus Ihrer Zielgruppe - von Fachkräften über Entscheider bis zu potenziellen Geschäftspartnern"
    },
    {
      icon: "TrendingUp",
      titel: "Markenpräsenz",
      beschreibung: "Stärken Sie Ihre Marke und positionieren Sie sich als Innovationsführer in Ihrer Branche"
    },
    {
      icon: "Handshake",
      titel: "Lead-Generierung",
      beschreibung: "Knüpfen Sie direkten Kontakt zu potenziellen Kunden, Partnern und Talenten"
    },
    {
      icon: "Presentation",
      titel: "Produktpräsentation",
      beschreibung: "Präsentieren Sie Ihre Produkte und Dienstleistungen einem aufmerksamen und interessierten Publikum"
    },
    {
      icon: "Users",
      titel: "Networking-Plattform",
      beschreibung: "Nutzen Sie exklusive Aussteller-Events zum Austausch mit anderen Unternehmen und Branchenexperten"
    },
    {
      icon: "LineChart",
      titel: "Marktforschung",
      beschreibung: "Gewinnen Sie wertvolle Einblicke in Markttrends und erhalten Sie direktes Feedback von Ihrer Zielgruppe"
    }
  ],

  ausstellerPakete: [
    {
      name: "Starter Paket",
      groesse: "12 m²",
      features: [
        "Standfläche inkl. Grundausstattung",
        "Firmenlogo im Messekatalog",
        "2 Ausstellerausweise",
        "Basis-Werbematerialien"
      ]
    },
    {
      name: "Professional Paket",
      groesse: "24 m²",
      features: [
        "Erweiterte Standfläche",
        "Premium-Platzierung im Katalog",
        "5 Ausstellerausweise",
        "Social Media Promotion",
        "Zugang zu Networking-Events"
      ]
    },
    {
      name: "Premium Paket",
      groesse: "48 m²",
      features: [
        "Exklusive Standfläche",
        "Hauptsponsor-Status",
        "10 Ausstellerausweise",
        "Umfassende Marketing-Kampagne",
        "Speaking-Slot auf Hauptbühne",
        "VIP Networking-Dinner"
      ]
    }
  ],

  kontakt: {
    email: "info@nextgenbusinesscup.com",
    telefon: "+49 173 6090971",
    adresse: "Schanzenstraße 6-20/Gebäude 1.21, 51063 Köln"
  },

  socialMedia: [
    { platform: "LinkedIn", url: "https://www.linkedin.com/company/next-gen-business-cup/?viewAsMember=true" },
    { platform: "Instagram", url: "https://www.instagram.com/nextgenbusinesscup/?utm_source=ig_web_button_share_sheet" },
    { platform: "TikTok", url: "https://www.tiktok.com/@nextgenbusinesscup" }
  ],
  linkedInUrl: "https://www.linkedin.com/company/next-gen-business-cup/posts",
  instagramUrl: "https://www.instagram.com/nextgenbusinesscup/",
  tiktokUrl: "https://www.tiktok.com/@nextgenbusinesscup"
};